import { render } from "./OrgUserManagement.vue?vue&type=template&id=7388c032&scoped=true"
import script from "./OrgUserManagement.vue?vue&type=script&lang=js"
export * from "./OrgUserManagement.vue?vue&type=script&lang=js"

import "./OrgUserManagement.vue?vue&type=style&index=0&id=7388c032&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7388c032"]])

export default __exports__